<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        <mat-step
          [formGroup]="scpi"
          [stepControl]="scpis?.get([i])"
          completed="false"
        >
          <ng-container formGroupName="parameters">
            <ng-template matStepLabel>{{
              scpi?.get('productName')?.value
            }}</ng-template>
            <div class="row row-flex">
              <ng-container formArrayName="idsProductsToCompareInRcda">
                @for (
                  control of scpi
                    .get('parameters')
                    .get('idsProductsToCompareInRcda').controls;
                  track control;
                  let j = $index
                ) {
                  <div class="col col-md-12">
                    <pr-input
                      label="{{
                        j === 0
                          ? 'Premier produit à comparer'
                          : 'Deuxième produit à comparer'
                      }}"
                      [derrors]="derrors"
                    >
                      <pr-select-search
                        [formControlName]="j"
                        label="{{
                          j === 0
                            ? 'Premier produit à comparer'
                            : 'Deuxième produit à comparer'
                        }}"
                        [options]="rcdaComparedProductsChoices"
                        optionDisplayKey="name"
                      ></pr-select-search>
                    </pr-input>
                  </div>
                }
              </ng-container>
            </div>
          </ng-container>
        </mat-step>
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
